import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogActions,
  MatDialogClose,
  MatDialogContent,
  MatDialogRef,
  MatDialogTitle,
} from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { NotificationViewModel } from '@components/notification-list/notification-list-table/notification-list-table.component';
import { MarkdownEditorComponent } from '@components/shared/markdown-editor/markdown-editor.component';
import { MarkdownModule, MarkdownService, provideMarkdown } from 'ngx-markdown';

@Component({
  selector: 'app-notification-detail-dialog',
  standalone: true,
  imports: [
    MatDialogTitle,
    MatDialogContent,
    MatDialogActions,
    MatDialogClose,
    MatIconModule,
    MatButtonModule,
    CommonModule,
    MarkdownEditorComponent,
    MarkdownModule,
  ],
  templateUrl: './notification-detail-dialog.component.html',
  styleUrl: './notification-detail-dialog.component.scss',
  providers: [provideMarkdown(), MarkdownService],
})
export class NotificationDetailDialogComponent {
  public notification: NotificationViewModel = {
    messageId: '',
    releaseAt: '',
    title: '',
    content: '',
  };

  constructor(
    @Inject(MAT_DIALOG_DATA) options: NotificationViewModel,
    private dialogRef: MatDialogRef<NotificationDetailDialogComponent>,
    private dialog: MatDialog,
  ) {
    this.notification = { ...options };
  }
}
